import PropTypes from 'prop-types';

import {OEObjectModelValueTypes, OEObjectModelValueEditTypes, OEObjectModelValueCellStyleOptions} from '../../../elements/object-model-value-edit/oe-object-model-value-edit-model';
import {OEFunctionProps} from '../function/oe-function-model';

export const OESmartAttributeType = {
    dummy:                          0,
    debugOutput:                    1,
};

//
export const SmartAttributeSignalFlags = {
    none:                           0,
    allowDeferred:                  1
};

//
export const OESmartAttributeIcons = {
    dummy:                          '\u00FF',
    debugOutput:                    '\uF27B',
};

//
export const OESmartAttributeChangeFlags = {
    userRef:                        1,
    params:                         2,
    eventFunc:                      4
};

//
export const OESmartAttributeControllerBtnIds = {
    dumpAttribute:                  'dumpAttribute'
};

//
export const OESmartAttributeParameterModel = {

    userRef: {
        userRef:                    {type: OEObjectModelValueTypes.string, showType: false}
    },

    debugOutput: {
        text:                       {type: OEObjectModelValueTypes.string, allowUndefined: true, showType: false}
    }
};

//
export class OESmartAttributeHelperClass {

    constructor(types = OESmartAttributeType, icons = OESmartAttributeIcons, parameterModel = OESmartAttributeParameterModel)   {

        this.stringMap = {};

        if(typeof(types) === 'object' && types) {
            Object.keys(types).forEach(key => {
                this.stringMap[String(types[key])] = key;
            });
        }

        this.icons = icons;
        this.parameterModel = parameterModel;

        this.typeToString = this.typeToString.bind(this);
        this.iconForType = this.iconForType.bind(this);
        this.parameterModelForType = this.parameterModelForType.bind(this);
    }

    typeToString(type) {
        return typeof(type) === 'number' ? this.stringMap[String(type)] : undefined;
    }

    iconForType(type) {
        let str = this.typeToString(type);
        return str && this.icons[str] ? this.icons[str] : '\u00FF';
    }

    parameterModelForType(type) {
        let str = this.typeToString(type);
        return str && this.parameterModel[str] ? this.parameterModel[str] : {};
    }
}

export const OESmartAttributeHelper = new OESmartAttributeHelperClass();

//
export const OESmartAttributeProps = {

    addAttributeMenuTypes:          PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.shape({
                type:                       PropTypes.number.isRequired,
                allowMultipleInstances:     PropTypes.bool,
                incompatibleTypes:          PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
            })
        ])
    ),

    attributeEventDecl: {
        name:                       PropTypes.string,
        function:                   OEFunctionProps.func
    },

    attributeSignalDecl: {
        name:                       PropTypes.string,
        flags:                      PropTypes.number,
        groups:                     PropTypes.number,
    }
};

OESmartAttributeProps.addEventFunctionMenuTypes = OEFunctionProps.addFragmentMenuTypes;

OESmartAttributeProps.attributeEvent = PropTypes.shape(OESmartAttributeProps.attributeEventDecl);

OESmartAttributeProps.attributeSignal = PropTypes.shape(OESmartAttributeProps.attributeSignalDecl);

OESmartAttributeProps.attributeDecl = {
    id:                             PropTypes.number.isRequired,
    type:                           PropTypes.number.isRequired,
    userRef:                        PropTypes.string,
    params:                         PropTypes.object,
    events:                         PropTypes.arrayOf(OESmartAttributeProps.attributeEvent),
    signals:                        PropTypes.arrayOf(OESmartAttributeProps.attributeSignal)
};

OESmartAttributeProps.attribute = PropTypes.shape(OESmartAttributeProps.attributeDecl);

OESmartAttributeProps.propTypes = {
    moduleId:                       PropTypes.string,
    className:                      PropTypes.string,
    iconForType:                    PropTypes.func,
    disabled:                       PropTypes.bool,
    parameterModelForType:          PropTypes.func,
    addAttributeMenuTypes:          OESmartAttributeProps.addAttributeMenuTypes,
    addEventFunctionMenuTypes:      OESmartAttributeProps.addEventFunctionMenuTypes,
    attributes:                     PropTypes.arrayOf(OESmartAttributeProps.attribute),
    onAttributeAddRequest:          PropTypes.func,
    onAttributeRemoveRequest:       PropTypes.func,
    onAttributeChangeRequest:       PropTypes.func
};

OESmartAttributeProps.defaultProps = {
    moduleId:                       '',
    className:                      '',
    disabled:                       false,
    iconForType:                    OESmartAttributeHelper.iconForType,
    parameterModelForType:          OESmartAttributeHelper.parameterModelForType,
    addAttributeMenuTypes: [
        OESmartAttributeType.debugOutput
    ],
    addEventFunctionMenuTypes:      OEFunctionProps.defaultProps.addFragmentMenuTypes
};